import React from 'react';

import { useIsMobileBreakpoint } from 'hooks/use-media-query';

import { LoyaltyLogoContainer, StyledLogo } from './loyalty-logo-widget.styled';

const LoyaltyLogoWidget = () => {
  const isMobile = useIsMobileBreakpoint();
  return (
    <LoyaltyLogoContainer testID="loyalty-logo-widget">
      <StyledLogo
        pictureSize={{
          height: isMobile ? '$16' : '$32',
          width: '4/5',
        }}
      />
    </LoyaltyLogoContainer>
  );
};

export default LoyaltyLogoWidget;
